import { refreshAccessToken } from "./apiClient";
import { API_URL } from "./constant";

// helper for getting the users wallet data
async function attempGetUserCredits(page,page_size,token,searchTerm,orgFilter) {
    const params = new URLSearchParams({
        page,
        page_size:page_size
    })

    if (searchTerm) params.append('search',searchTerm);
    if(orgFilter) params.append('user__org',orgFilter)

    const response = await fetch(`${API_URL}/payments/wallet/?${params.toString()}`,{
        method:'GET',
        headers:{
            'Authorization': `Bearer ${token}`,
        }
    })

    const responseData = await response.json();

    if(!response.ok){
        const err = new Error("Failed to fetch the wallet data");
        err.data = responseData;
        err.status = response.status;
        throw err;
    }

    return responseData
}
// main function to get the wallet data
export async function getUsersWallet(page,page_size,searchTerm,orgFilter) {
    let accessToken = JSON.parse(localStorage.getItem('accessToken'));
    try{
        return await attempGetUserCredits(page,page_size,accessToken,searchTerm,orgFilter);
    }catch(error){
        if(error.status === 401){
            try{
                const newAccessToken = await refreshAccessToken();
                return await attempGetUserCredits(page, page_size, newAccessToken);
            }catch(refreshError){
                console.log("Token refresh failed",refreshError.message);
                throw refreshError;
            }
        }
        console.log("Error while getting org list", error?.data || error.message);
        throw error;
    }
}

// helper function to update the wallet
async function attempUpdateUserWallet(data,token) {
    console.log("lowbalance alert",data.low_bal_alert)
    const walletEditData={};
    if(data.free_credit) walletEditData.free_credit = data.free_credit;
    if(data.debt_credit) walletEditData.debt_credit = data.debt_credit;
    // if(data.low_bal_alert) walletEditData.low_bal_alert = data.low_bal_alert;
    // if(data.threshold) walletEditData.threshold = data.threshold;
    
    // if (data.free_credit !== undefined)
    // walletEditData.free_credit = data.free_credit;

    // if (data.debt_credit !== undefined)
    //     walletEditData.debt_credit = data.debt_credit;

    if (data.low_bal_alert !== undefined)
        walletEditData.low_bal_alert = data.low_bal_alert;

    if (data.threshold !== undefined)
        walletEditData.threshold = data.threshold;

    console.log("wallet data",walletEditData)
    const response = await fetch(`${API_URL}/payments/wallet/${data.id}/add_credit/`,{
        method:'PATCH',
        headers:{
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(walletEditData)
    })

    const responseData = await response.json()

    if (!response.ok){
        const err = new Error("Updating Product failed")
        err.data = responseData;
        err.status = response.status;
        throw err;
    }
    return responseData;
}
// main dunction to update the wallet
export async function updateWallet(data) {
    let accessToken= JSON.parse(localStorage.getItem('accessToken'));
    try{
        return await attempUpdateUserWallet(data,accessToken);
    }catch(error){
        if (error.status === 401){
            try{
                const newAccessToken = await refreshAccessToken();
                return await attempUpdateUserWallet(data,newAccessToken);
            }catch(refreshError){
                console.log("Token refresh Failed", refreshError.message)
                throw refreshError;
            }
        }
        console.log("Error while updating the user wallet", error?.data || error.message)
        throw error;
    }
}

// helper function to edit the wallet credits
async function attemptEditUserWallet(data, token) {
    const walletEditData = {};

    if (data.free_credit !== undefined)
        walletEditData.free_credit = data.free_credit;

    if (data.debt_credit !== undefined)
        walletEditData.debt_credit = data.debt_credit;

    if (data.debt_owned !== undefined)
        walletEditData.debt_owned = data.debt_owned;

    if (data.low_bal_alert !== undefined)
        walletEditData.low_bal_alert = data.low_bal_alert;

    if (data.threshold !== undefined)
        walletEditData.threshold = data.threshold;

    const response = await fetch(
        `${API_URL}/payments/wallet/${data.id}/edit_credit/`,
        {
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
            body: JSON.stringify(walletEditData),
        }
    );

    const responseData = await response.json();

    if (!response.ok) {
        const err = new Error("Updating wallet credits failed");
        err.data = responseData;
        err.status = response.status;
        throw err;
    }

    return responseData;
}

// main function to edit the wallet credits
export async function editWallet(data) {
    let accessToken = JSON.parse(localStorage.getItem("accessToken"));

    try {
        return await attemptEditUserWallet(data, accessToken);
    } catch (error) {
        if (error.status === 401) {
            try {
                const newAccessToken = await refreshAccessToken();
                return await attemptEditUserWallet(data, newAccessToken);
            } catch (refreshError) {
                console.log("Token refresh failed", refreshError.message);
                throw refreshError;
            }
        }

        console.log(
            "Error while editing wallet credits",
            error?.data || error.message
        );
        throw error;
    }
}

// get wallet data for specific user only
async function attemptGetUserWallet(token) {
    const response = await fetch(`${API_URL}/payments/wallet/`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

    const responseData = await response.json();

    if (!response.ok) {
        const err = new Error("Failed to fetch wallet data");
        err.data = responseData;
        err.status = response.status;
        throw err;
    }

    return responseData;
}

export async function getUserWallet() {
    let accessToken = JSON.parse(localStorage.getItem("accessToken"));

    try {
        return await attemptGetUserWallet(accessToken);
    } catch (error) {
        if (error.status === 401) {
            const newAccessToken = await refreshAccessToken();
            return await attemptGetUserWallet(userId, newAccessToken);
        }

        throw error;
    }
}